<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <div class="flex pb-5">
          <div class="flex-1">
            {{ $t("sections.accounting.dataForm.itemCounts", { max: notificationContractsSale.length }) }}
          </div>
        </div>
        <vs-table :data="notificationContractsSale">
          <template slot="thead">
            <vs-th>{{ $t("sections.accounting.dataForm.no") }}</vs-th>
            <vs-th>{{ $t("sections.accounting.dataForm.contractNo") }}</vs-th>
            <vs-th>{{ $t("sections.accounting.dataForm.contractDate") }}</vs-th>
            <vs-th>{{ $t("sections.accounting.dataForm.contractName") }}</vs-th>
            <vs-th>วงเงินกู้ (ยอดโอนให้มหาวิทยาลัย)</vs-th>
            <vs-th>สถานะงาน</vs-th>
            <vs-th sort-key="" class="w-1/12"></vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="contract" :key="index" v-for="(contract, index) in data">
              <vs-td>
                {{ index+1 }}
              </vs-td>
              <vs-td :data="contract.contractNo">
                <router-link :to="{ name: 'notification-sale-detail', params: {id: contract.id}}">{{ contract.contractNo }}</router-link>
              </vs-td>
              <vs-td :data="contract.contractDate">
                {{ contract.contractDate | convYYYYMMDDToDDMMYYYY }}
              </vs-td>
              <vs-td :data="contract.contractName">
                {{ contract.contractName }}
              </vs-td>
              <vs-td :data="contract.contractAmount">
                {{ contract.contractAmount | numberFormat  }}
              </vs-td>
              <vs-td>
                {{ contract.smartAppStatusName }}
<!--                <a @click="$refs.suretyDetailsPopup.handlePopup(contract.suretyDetails, 'suretyDetails')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="cursor-pointer"/></a>-->
              </vs-td>
              <vs-td>
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-file-text" @click="print(contract.id)" ></vs-button>
                  <vs-button v-if="contract.smartAppStatus === 'Approved' && contract.contractStatus === 'Draft'" class="p-5" color="danger" type="flat" icon-pack="feather"  icon="icon-x-circle" @click="rejected(contract.id)"></vs-button>
                  <vs-button v-if="contract.smartAppStatus === 'Approved' && contract.contractStatus === 'Draft'" class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-check-square"  @click="inspectioned(contract.id)" ></vs-button>
                  <vs-button v-if="contract.smartAppStatus === 'Inspectioned' && contract.contractStatus === 'Draft'" class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-check-square"  @click="success(contract.id)" ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <custom-popup ref="suretyDetailsPopup" title="รายละเอียผู้ค้ำประกัน"/>
        <vs-prompt
          @accept="acceptRejected"
          color="danger"
          :title="$t('notification.confirm-reject-title')"
          :active.sync="modalReject">
          <div class="con-exemple-prompt">
            {{ $t('notification.confirm-reject-message') }}
            <vs-textarea placeholder="คำอธิบาย" v-model="modalRejectRemark" class="mt-4 mb-2 w-full" rows="5"/>
          </div>
        </vs-prompt>
      </vx-card>
    </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapNotificationActions, mapState: mapNotificationState } = createNamespacedHelpers('Notification')
import CustomPopup from '@/views/components/custom/Popup'
export default {
  components: {
    CustomPopup
  },
  data(){
    return {
      modalReject:false,
      modalRejectRemark: '',
    }
  },
  async created () {
    const vm = this
    const { getNotificationContractsSale } = vm
    await getNotificationContractsSale({
      action: vm.$route.params.action,
    })
  },
  computed: {
    ...mapNotificationState(['status', 'notificationContractsSale']),
  },
  methods: {
    ...mapNotificationActions(['getNotificationContractsSale', 'rejectedContractWithSmartApp', 'inspectionedContractWithSmartApp', 'successContractWithSmartApp']),
    async print (id) {
      await this.$router.push({name: 'accounting-contract-print-sale', params: {id: id}})
    },
    async rejected (id) {
      const vm = this;
      vm.actionID = id
      vm.modalReject = true;
      vm.modalRejectRemark = "";
    },
    async acceptRejected(){
      const vm = this;
      const {rejectedContractWithSmartApp, getNotificationContractsSale} = vm;
      await rejectedContractWithSmartApp({
        id: vm.actionID,
        form: {
          remark: vm.modalRejectRemark,
        },
        vm
      });
      await getNotificationContractsSale({
        action: vm.$route.params.action,
      });
    },
    async inspectioned (id) {
      const vm = this;
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: vm.$t('notification.confirm-inspectioned-title'),
        text: vm.$t('notification.confirm-inspectioned-message'),
        accept: vm.acceptInspectioned
      })
    },
    async acceptInspectioned () {
      const vm = this;
      const {inspectionedContractWithSmartApp, getNotificationContractsSale} = vm;
      await inspectionedContractWithSmartApp({
        id: vm.actionID,
        vm
      });
      await getNotificationContractsSale({
        action: vm.$route.params.action,
      });
    },
    async success (id) {
      const vm = this;
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: vm.$t('notification.confirm-payment-title'),
        text: vm.$t('notification.confirm-payment-message'),
        accept: vm.acceptSuccess
      })
    },
    async acceptSuccess () {
      const vm = this;
      const {successContractWithSmartApp, getNotificationContractsSale} = vm;
      await successContractWithSmartApp({
        id: vm.actionID,
        vm
      });
      await getNotificationContractsSale({
        action: vm.$route.params.action,
      });
    },
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
